export default __webpack_public_path__ + "static/wp-front-29feaa313f042bafabb141456b3d022e.png";